import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';
import { ReactComponent as CircleCheckIcon } from 'assets/icons/circle_check.svg';
import { ReactComponent as CircleCheckOnIcon } from 'assets/icons/circle_check_on.svg';
import styles from 'styles/components/pages/common/ChartSwiper.module.scss';
import { ChartInfo } from 'constants/chart/common/chartInfo';
import { TChartGradingStatus } from 'types/chart';

type TProps = {
  data?: TChartGradingStatus[] | undefined;
  height?: number;
  padding?: string;
  marginBottom?: string;
  fontSize?: string;
  iconWidth?: number;
  iconHeight?: number;
};

const defaultValues = ChartInfo.map((chart) => ({
  chartName: chart.name,
  status: null,
}));

const ChartSwiper = ({
  data = defaultValues,
  height = 90,
  padding = '8px 24px 10px 16px',
  marginBottom,
  fontSize = '14px',
  iconWidth = 40,
  iconHeight = 40,
}: TProps) => {
  const slidesPerPage = 8;

  const totalPages = Math.ceil(data.length / slidesPerPage);

  const slides = [];
  for (let page = 0; page < totalPages; page++) {
    const startIndex = page * slidesPerPage;
    const endIndex = startIndex + slidesPerPage;
    const pageItems = data.slice(startIndex, endIndex);

    slides.push(
      <SwiperSlide key={page}>
        <div
          className={styles.chart_wrapper}
          style={{ marginBottom: marginBottom }}
        >
          {pageItems.map((item, index) => (
            <div
              className={
                item.status === null
                  ? styles.chart_card_disabled
                  : styles.chart_card
              }
              key={index}
              style={{ height: height, padding: padding }}
            >
              <p className={styles.chart_name} style={{ fontSize: fontSize }}>
                {item.chartName}
              </p>
              <div className={styles.chart_icon}>
                {item.status === 2 ? (
                  <CircleCheckOnIcon width={iconWidth} height={iconHeight} />
                ) : item.status === 1 ? (
                  <CircleCheckIcon width={iconWidth} height={iconHeight} />
                ) : (
                  ''
                )}
              </div>
            </div>
          ))}
        </div>
      </SwiperSlide>
    );
  }

  return (
    <Swiper pagination={true} modules={[Pagination]}>
      {slides}
    </Swiper>
  );
};

export default ChartSwiper;
